
/**
 * @fileOverview ComparisonValidator Module File
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;


    define('controllers/ComparisonValidator',['require','jquery','lib/Util'],function (require) {
        var $ = require('jquery');
        var Util = require('lib/Util');

        /**
         * This checks to see that comparison is done by between 2 to 3 elements. If not it will return a message,
         * via an alert. Alerts are configured with data-options on the form element containing the comparison items
         * Only language may be configured, default is English.
         *
         * @class ComparisonValidator
         * @param {string} ID passed in to form, changed into a JQuery object in init.
         * @constructor
         */
        var ComparisonValidator = function (formId) {
            this.$form = $(formId);
            this.init();
        };

        /**
         *
         * This takes in data options from the markup and overwrites base values. If there is no value in the data
         * options tag then defaults are shown below.
         *
         * @method setOptions
         * @returns {ComparisonValidator}
         * @private
         */

        ComparisonValidator.prototype.setOptions = function() {
            var options;

            if (this.$form.data() !== null && this.$form.data() !== undefined) {
                options = this.$form.data().options;
            } else {
                options = null;
            }

            var defaults = {
                minimumMessage : 'You must select more than one item to compare.',
                maximumMessage : 'You can not compare more than 3 items at a time.'
            };
            this.settings = $.extend({}, defaults, options);

            return this;
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         *
         * @method init
         * @returns {ComparisonValidator}
         * @private
         */
        ComparisonValidator.prototype.init = function () {
            this.isEnabled = false;
           // $debug('ComparisonValidator.js initialized');
            this.setOptions()
                .comparisonValidation();

            return this;
        };

        /**
         *
         * This function checks the form on submit. If less than two items are checked it fires off the
         * minimumMessage as defined in the settings. If more than three items are checked it fires off
         * the maximumMessage as defined in the settings. If it is between two to three items it returns
         * true and allows the submit.
         *
         * @method comparisonValidation
         * @returns {ComparisonValidator}
         * @private
         */
        ComparisonValidator.prototype.comparisonValidation = function () {
            var self = this;
            this.$form.submit(function () {
                if(self.$form.find('input[type=checkbox]:checked').length < 2) {
                    window.alert(self.settings.minimumMessage);
                    return false;
                } else if (self.$form.find('input[type=checkbox]:checked').length > 3 ){
                    window.alert(self.settings.maximumMessage);
                    return false;
                } else {
                    return true;
                }
            });

            return this;
        };

        return ComparisonValidator;
    });

}(MMMRequire));
